import { render, staticRenderFns } from "./OnboardingSharedCard.vue?vue&type=template&id=31ee9da6&"
import script from "./OnboardingSharedCard.vue?vue&type=script&lang=js&"
export * from "./OnboardingSharedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports